import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _UserStatusMessage_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { setOwner } from "@ember/application";
import { service } from "@ember/service";
import { until } from "discourse/lib/formatter";
import { emojiUnescape } from "discourse/lib/text";
import { escapeExpression } from "discourse/lib/utilities";
import User from "discourse/models/user";
export let UserStatusMessage = (_class = (_UserStatusMessage_brand = /*#__PURE__*/new WeakSet(), class UserStatusMessage {
  constructor(owner, _status, _opts) {
    _classPrivateMethodInitSpec(this, _UserStatusMessage_brand);
    _initializerDefineProperty(this, "tooltip", _descriptor, this);
    _defineProperty(this, "html", null);
    _defineProperty(this, "content", null);
    setOwner(this, owner);
    this.html = _assertClassBrand(_UserStatusMessage_brand, this, _statusHtml).call(this, _status, _opts);
    this.content = _assertClassBrand(_UserStatusMessage_brand, this, _tooltipHtml).call(this, _status);
    this.tooltipInstance = this.tooltip.register(this.html, {
      identifier: "user-status-message-tooltip",
      content: this.content
    });
  }
  destroy() {
    if (this.tooltip.isDestroyed) {
      return;
    }
    this.tooltipInstance.destroy();
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "tooltip", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
function _emojiHtml(emojiName) {
  const emoji = escapeExpression(`:${emojiName}:`);
  return emojiUnescape(emoji, {
    skipTitle: true
  });
}
function _statusHtml(status, opts) {
  const html = document.createElement("span");
  html.classList.add("user-status-message");
  if (opts?.class) {
    html.classList.add(opts.class);
  }
  html.innerHTML = _assertClassBrand(_UserStatusMessage_brand, this, _emojiHtml).call(this, status.emoji);
  if (opts?.showDescription) {
    const description = document.createElement("span");
    description.classList.add("user-status-message-description");
    description.innerText = status.description;
    html.appendChild(description);
  }
  return html;
}
function _tooltipHtml(status) {
  const html = document.createElement("div");
  html.classList.add("user-status-message-tooltip");
  html.innerHTML = _assertClassBrand(_UserStatusMessage_brand, this, _emojiHtml).call(this, status.emoji);
  const description = document.createElement("span");
  description.classList.add("user-status-tooltip-description");
  description.innerText = status.description;
  html.appendChild(description);
  if (status.ends_at) {
    const untilElement = document.createElement("div");
    untilElement.classList.add("user-status-tooltip-until");
    untilElement.innerText = _assertClassBrand(_UserStatusMessage_brand, this, _until).call(this, status.ends_at);
    html.appendChild(untilElement);
  }
  return html;
}
function _until(endsAt) {
  const currentUser = User.current();
  const timezone = currentUser ? currentUser.user_option?.timezone : moment.tz.guess();
  return until(endsAt, timezone, currentUser?.locale);
}